export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "user_selection_buttons": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["User Selection Buttons"])},
        "select_all": {
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toggle all"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Toggle selection of users"])}
        },
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading..."])}
      },
      "fr": {
        "user_selection_buttons": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Boutons de selection de l'utilisateur"])},
        "select_all": {
          "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tout basculer"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Basculer la sélection des utilisateurs"])}
        },
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chargement..."])}
      }
    }
  })
}